export const filterByLabel = (input: string, option: any) => {
  const label = option?.label;
  if (typeof label === "string") {
    return label.toLowerCase().includes(input.toLowerCase());
  }
  return false;
};
